import React from 'react'
import SectionHeader from '@/components/SectionHeader'
import AdsDisclaimerTooltip from '@/components/AdsDisclaimerTooltip/AdsDisclaimerTooltip'
import { isNonEmptyString } from '@/utils/checks'
import { Center } from '@/types/models'
import { THtmlElementHeading } from '@/types/HtmlElements'
import { CarouselInfo } from '@/components/AdminTool/CarouselInfo'
import Button from '@/components/atoms/Button/ButtonV2'
import { HeaderWeight, HeaderSize } from './CenterCarousel'

interface CenterCarouselHeaderProps {
  (props: {
    className?: string
    centers: Center[]
    isLoading: boolean
    sectionHeading?: string
    sectionSubHeading?: string
    HeaderTag?: THtmlElementHeading
    headerAlignment?: 'left' | 'center' | 'right'
    headerSize?: HeaderSize
    headerWeight?: HeaderWeight
    useFieldsVariable?: boolean
    allCentersArePPV?: boolean
    shouldShowCta?: boolean
    SubHeaderTag?: THtmlElementHeading
    subheaderAlignment?: 'left' | 'center' | 'right'
    subheaderSize?: HeaderSize
    subheaderWeight?: HeaderWeight
    termTitle?: string
    shouldHideAdTags?: boolean
    headerLink?: string
    headerLinkText?: string
  }): JSX.Element | null
}

const CenterCarouselHeader: CenterCarouselHeaderProps = ({
  centers = [] as Center[],
  isLoading = true,
  sectionHeading = '',
  HeaderTag = 'p',
  headerAlignment = 'left',
  headerSize = 'lg',
  headerWeight = 'medium',
  sectionSubHeading = '',
  SubHeaderTag = 'p',
  useFieldsVariable = false,
  allCentersArePPV = false,
  shouldShowCta = false,
  headerLink,
  headerLinkText
}) => {
  return (
    <SectionHeader>
      <div className="flex items-end justify-between">
        <div className="flex flex-col">
          <HeaderTag
            className={`${
              useFieldsVariable ? 'font-FieldsVariable' : ''
            } text-${headerAlignment} text-${headerSize} font-${headerWeight} leading-6 tracking-normal text-gray-1100`}
          >
            {sectionHeading}
          </HeaderTag>
          {isNonEmptyString(sectionSubHeading) && (
            <SubHeaderTag className="mt-1 max-w-[680px] text-base font-normal text-gray-700">
              {sectionSubHeading}
            </SubHeaderTag>
          )}
        </div>
        {!isLoading && <CarouselInfo centers={centers} />}
        <div className="flex items-center gap-2">
          {allCentersArePPV && <AdsDisclaimerTooltip />}
          {allCentersArePPV && shouldShowCta && (
            <span className="text-gray-400"> | </span>
          )}
          {shouldShowCta && (
            <Button
              type="tertiary"
              className="hidden ease-in-out md:block"
              as="a"
              href={headerLink}
            >
              {headerLinkText}
            </Button>
          )}
        </div>
      </div>
    </SectionHeader>
  )
}

export default CenterCarouselHeader
